<script setup>
import {Link, router} from "@inertiajs/vue3";
import Menu from "primevue/menu";
import { ref } from "vue";
import {getInitials} from "../../../../helpers.js";

defineProps({
    forms: Object,
});

const menu = ref(null);

const userOptions = [
    {
        label: "Odhlásit se",
        icon: "pi pi-sign-out",
        command: () => router.visit('/logout'),
    },
];
</script>

<template>
    <div v-if="$page.props.adminPanel" class="w-full p-2 fixed px-4 z-10 bg-black text-white">
        <div class="flex items-center gap-4 max-w-[984px] mx-auto">
            <Link href="/">
                <div class="bg-prod-dark-logo w-[72px] bg-no-repeat bg-center h-[24px]"></div>
            </Link>
            <div class="h-[16px] max-md:hidden border-l opacity-50"></div>
            <div class="flex max-md:hidden items-center gap-2 grow overflow-ellipsis">
                <span
                    :class="'pi pi-' + (forms.form_type.name === 'personal' ? 'user' : 'briefcase')"
                    class="!text-sm opacity-70 text-white"
                ></span>
                <p class="text-sm text-white tracking-wide">
                    {{ forms.name }}
                </p>
            </div>
            <div class="flex items-center gap-4 grow justify-end">
                <button
                    class="flex items-center gap-2 px-4 py-1 text-sm bg-blue-500 hover:bg-blue-700 text-white rounded-full"
                    @click="router.visit(`/app/forms/${forms.slug}`)"
                >
                    <i class="pi pi-pencil !text-sm"></i>
                    <!-- Rezervační formulář -->
                    {{ $t('widget.reservation_form') }}
                </button>
                <Link href="/app/reservations" class="max-sm:hidden flex items-center gap-2 text-sm text-white hover:underline">
                    <i class="pi pi-calendar"></i>
                    <!-- Rezervace -->
                    {{ $t('widget.reservations') }}
                </Link>
            </div>
            <div class="flex items-center gap-2 relative">
                <p
                    class="bg-white w-[20px] h-[20px] text-black flex justify-center items-center rounded-full text-xs cursor-pointer"
                    @click="menu.toggle($event)"
                >
                    {{getInitials($page.props.adminPanel?.name)}}
                </p>
                <Menu :model="userOptions" ref="menu" popup />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

.p-menu {
    background-color: #222 !important;
    border-radius: 8px !important;
    color: white !important;
    padding: 0.5rem 0 !important;
}

.p-menu .p-menuitem-link {
    color: white !important;
    opacity: 0.85;
    padding: 0.75rem 1.5rem !important;
    border-radius: 6px;
}

.p-menu .p-menuitem-link:hover {
    background-color: #444 !important;
    color: #fff !important;
}
</style>
